if(typeof CustomDrawer === 'undefined') {
  class CustomDrawer extends HTMLElement {
    constructor() {
      super()

      this.selectors = {
        toggler: '[data-drawer-toggler]',
        drawerContent: '[data-drawer-content]',
      }
    }

    connectedCallback() {
      this.toggler = this.querySelector(this.selectors.toggler);
      this.drawerContent = this.querySelector(this.selectors.drawerContent);
      this.open = this.className.indexOf('is-open') > -1;
      this.loading = false;

      // define values after initialization
      this.contentHeight = this.drawerContent.scrollHeight;

      this.toggler.addEventListener('click', this.toggleDrawer.bind(this));
    }

    toggleDrawer() {
      if(this.loading === true) return;

      this.open = !this.open;
      this.loading = true;
      if(this.open) {
        this.openDrawer();
      } else {
        this.closeDrawer();
      }
    }

    openDrawer() {
      this.drawerContent.classList.remove('hidden');

      const contentHeight = this.drawerContent.scrollHeight;
      this.drawerContent.style.height = `${contentHeight}px`;

      this.drawerContent.focus();
      this.classList.add('is-open');
      this.toggler.setAttribute('aria-expanded', 'true');
      this.drawerContent.removeAttribute('aria-hidden');

      this.addEventListener('transitionend', () => {
        this.drawerContent.style.height = 'auto';
        this.loading = false;
      }, {once: true})
    }

    closeDrawer() {
      const contentHeight = this.drawerContent.scrollHeight;
      this.drawerContent.style.height = `${contentHeight}px`;

      setTimeout(() => {
        this.drawerContent.style.height = '0';
      }, 100);

      this.toggler.focus();
      this.classList.remove('is-open');
      this.toggler.setAttribute('aria-expanded', 'false');

      this.drawerContent.addEventListener('transitionend', () => {
        this.drawerContent.setAttribute('aria-hidden', 'true');
        this.drawerContent.classList.add('hidden');
        this.loading = false;
      }, { once: true });
    }
  }

  if(!window.customElements.get('custom-drawer')) {
    customElements.define('custom-drawer', CustomDrawer);
  }
}
